/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { Company, VersionedPagination } from "../../utils/Interfaces";

export interface CompaniesState {
    existingCompanies: Company[];
    existingCompaniesCount: number;
    companiesLoaded: boolean;
    companiesVersion: string;
}

const initialState: CompaniesState = {
    existingCompanies: [],
    existingCompaniesCount: 0,
    companiesLoaded: false,
    companiesVersion: "",
};

export const companiesSlice = createSlice({
    name: "companies",
    initialState,
    reducers: {
        setExistingCompanies: (state, action: PayloadAction<VersionedPagination<Company>>) => {
            state.existingCompanies = action.payload.results;
            state.existingCompaniesCount = action.payload.count;
            state.companiesLoaded = true;
            state.companiesVersion = action.payload.version;
        },
    },
});

export const { setExistingCompanies } = companiesSlice.actions;

export const selectExistingCompanies = (state: RootState) => state.companies.existingCompanies;
export const selectExistingCompaniesCount = (state: RootState) => state.companies.existingCompaniesCount;
export const selectExistingCompaniesLoaded = (state: RootState) => state.companies.companiesLoaded;
export const selectExistingCompaniesVersion = (state: RootState) => state.companies.companiesVersion;

export default companiesSlice.reducer;
